<section class="section-div">
  <div>
    <div class="header-div d-flex">
      <h4>
        <ion-icon name="grid-outline"></ion-icon> Incubation Management Areas -
        {{ incubaterName }} -
        <span class="cat-span">{{ dashboardData.category }}</span>
      </h4>
      <div
        class="ml-auto"
        *ngIf="
          dashboardData.enableScoring != 0 &&
          dashboardData.enableScoring != undefined
        "
      >
        <button class="custom-btn btn-11" (click)="scoreGenerate()">
          <span *ngIf="dashboardData.enableScoring == 1">Generate Score</span>
          <span *ngIf="dashboardData.enableScoring == 2">Regenerate Score</span>
          <div class="dot"></div>
        </button>
      </div>
    </div>
    <div class="div-bg">
      <main class="main-one">
        <div class="activity-container">
          <h6>Not Implemented</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              Action Items
              <span
                >({{ dashboardData.notImplemented }}/{{
                  dashboardData.totalQuestions
                }})</span
              >
            </p>
            <div class="box-progress-bar">
              <span
                class="box-progress"
                [style.width.%]="
                  (dashboardData.notImplemented /
                    dashboardData.totalQuestions) *
                  100
                "
                style="background-color: #56c2e6"
              ></span>
            </div>
            <p class="box-progress-percentage">
              {{
                (dashboardData.notImplemented / dashboardData.totalQuestions) *
                  100 | number : "1.0-0"
              }}
              %
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>Under Review</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              Action Items
              <span
                >({{ dashboardData.underReview }}/{{
                  dashboardData.totalQuestions
                }})</span
              >
            </p>
            <div class="box-progress-bar">
              <span
                class="box-progress"
                [style.width.%]="
                  (dashboardData.underReview / dashboardData.totalQuestions) *
                  100
                "
                style="background-color: #ff5e7d"
              ></span>
            </div>
            <p class="box-progress-percentage">
              {{
                (dashboardData.underReview / dashboardData.totalQuestions) * 100
                  | number : "1.0-0"
              }}
              %
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>Clarification Requested</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              Action Items
              <span
                >({{ dashboardData.clarificationRequested }}/{{
                  dashboardData.totalQuestions
                }})</span
              >
            </p>
            <div class="box-progress-bar">
              <span
                class="box-progress"
                [style.width.%]="
                  (dashboardData.clarificationRequested /
                    dashboardData.totalQuestions) *
                  100
                "
                style="background-color: #4cce84"
              ></span>
            </div>
            <p class="box-progress-percentage">
              {{
                (dashboardData.clarificationRequested /
                  dashboardData.totalQuestions) *
                  100 | number : "1.0-0"
              }}
              %
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>Documents Rejected</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              Action Items
              <span
                >({{ dashboardData.documentRejected }}/{{
                  dashboardData.totalQuestions
                }})</span
              >
            </p>
            <div class="box-progress-bar">
              <span
                class="box-progress"
                [style.width.%]="
                  (dashboardData.documentRejected /
                    dashboardData.totalQuestions) *
                  100
                "
                style="background-color: #f1c75a"
              ></span>
            </div>
            <p class="box-progress-percentage">
              {{
                (dashboardData.documentRejected /
                  dashboardData.totalQuestions) *
                  100 | number : "1.0-0"
              }}
              %
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>Documents Approved</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              Action Items
              <span
                >({{ dashboardData.documentApproved }}/{{
                  dashboardData.totalQuestions
                }})</span
              >
            </p>
            <div class="box-progress-bar">
              <span
                class="box-progress"
                [style.width.%]="
                  (dashboardData.documentApproved /
                    dashboardData.totalQuestions) *
                  100
                "
                style="background-color: #ff8b64"
              ></span>
            </div>
            <p class="box-progress-percentage">
              {{
                (dashboardData.documentApproved /
                  dashboardData.totalQuestions) *
                  100 | number : "1.0-0"
              }}
              %
            </p>
          </div>
        </div>
      </main>
    </div>

    <div
      class="score-div"
      [ngClass]="{ 'd-block': dashboardData.enableScoring == 2 }"
    >
      <div class="bg-code">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="score-values">
              <div class="pro-div">
                <p class="percentage-span">
                  <ion-icon name="business-outline"></ion-icon> Management
                  Strategey
                  <span class="span-point"
                    >{{ dashboardData.tnimmManagementScore }}/10</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="
                      (dashboardData.tnimmManagementScore / 10) * 100
                    "
                    style="background-color: #abdcff"
                  ></span>
                </div>
              </div>
              <div class="pro-div">
                <p class="percentage-span">
                  <ion-icon name="happy-outline"></ion-icon> Knowledge &
                  Expertise
                  <span class="span-point"
                    >{{ dashboardData.tnimmKnowledgeScore }}/10</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="
                      (dashboardData.tnimmKnowledgeScore / 10) * 100
                    "
                    style="background-color: #4c83ff"
                  ></span>
                </div>
              </div>
              <div class="pro-div">
                <p class="percentage-span">
                  <ion-icon name="cash-outline"></ion-icon> Financial
                  <span class="span-point"
                    >{{ dashboardData.tnimmFinancialScore }}/10</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="
                      (dashboardData.tnimmFinancialScore / 10) * 100
                    "
                    style="background-color: #ffd3a5"
                  ></span>
                </div>
              </div>
              <div class="pro-div">
                <p class="percentage-span">
                  <ion-icon name="megaphone-outline"></ion-icon> HR
                  <span class="span-point"
                    >{{ dashboardData.tnimmHrScore }}/10</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="(dashboardData.tnimmHrScore / 10) * 100"
                    style="background-color: #5961f9"
                  ></span>
                </div>
              </div>
              <div class="pro-div">
                <p class="percentage-span">
                  <ion-icon name="layers-outline"></ion-icon> Physical
                  Infrastructure
                  <span class="span-point"
                    >{{ dashboardData.tnimmPhysicalInfraScore }}/10</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="
                      (dashboardData.tnimmPhysicalInfraScore / 10) * 100
                    "
                    style="background-color: #0396ff"
                  ></span>
                </div>
              </div>
              <div class="pro-div">
                <p class="percentage-span">
                  <ion-icon name="globe-outline"></ion-icon> Networking
                  Ecosystem
                  <span class="span-point"
                    >{{ dashboardData.tnimmNetworkScore }}/10</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="
                      (dashboardData.tnimmNetworkScore / 10) * 100
                    "
                    style="background-color: #ee9ae5"
                  ></span>
                </div>
              </div>
              <div class="pro-div">
                <p class="percentage-span">
                  <ion-icon name="earth-outline"></ion-icon> Social Impact
                  <span class="span-point"
                    >{{ dashboardData.tnimmSocialImpactScore }}/10</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="
                      (dashboardData.tnimmSocialImpactScore / 10) * 100
                    "
                    style="background-color: #2afadf"
                  ></span>
                </div>
              </div>
              <div class="pro-div mb-4">
                <p class="percentage-span">
                  <ion-icon name="newspaper-outline"></ion-icon> Result &
                  Outcome
                  <span class="span-point"
                    >{{ dashboardData.tnimmResultScore }}/15</span
                  >
                </p>
                <div class="progress-bars">
                  <span
                    class="progress"
                    [style.width.%]="
                      (dashboardData.tnimmResultScore / 10) * 100
                    "
                    style="background-color: #fd6585"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="text-center">
              <h5>Total Score</h5>
            </div>
            <div id="chart"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
